export default {
	reports: {
		contact: 'Kontakt',
		reportedBy: 'Gemeldet von',
		callback_number: 'Rückrufnummer',
		emails: '@:common.emails',
		sendEmail: 'Mailversand',
		to: 'An',
		subject: '@:common.subject',
		publicLabel: 'öffentlich',
		emailConflict:
			'Die interne Markierung ist mit dem E-Mail-Versand nicht möglich',
		markAsInternal: 'Kommentar als intern markieren',
		internalInfo: 'Der Kommentar wird nur der Hausverwaltung angezeigt',
		visibleToAdmin: 'Dies wird nur der Hausverwaltung angezeigt',
		linkData: 'Daten verknüpfen',
		category: '@:common.category',
		subCategory: 'Unterkategorie',
		createReport: 'Meldung verfassen',
		disabledNotifications:
			'Der Versand von Benachrichtigungen ist deaktiviert, bitte aktivieren Sie diesen zuerst um die Funktion zu verwenden',
		rejectionReasonOptional: 'Grund für die Ablehnung angeben (optional)',
		dataChangeRequestFrom: 'Datenänderungsanfrage vom ',
		assignToMe: 'Mir zuweisen',
		callbackNumber: 'Telefonnummer für Rückfragen',
		alternativeCallbackNumber: 'Alternative Telefonnumer für Rückfragen',
		resetFilters: 'Filter zurücksetzen',
		thankYouQuestion:
			'Vielen Dank, dass Sie unsere digitale Plattform nutzen. Was möchten Sie melden?',
		enterDamageCategory:
			'Bitte hinterlegen Sie an dieser Stelle die Kategorie des Schadens.',
		importantNote:
			'Wichtig: Hinter allen Kategorien, außer der Allgemeinen Nachricht, werden weitere Abfragen erfolgen.',
		specifyDamage: 'Definieren Sie nun den Schaden genauer.',
		internalNotes:
			'Intern markierte Meldungen sind nur für den Hausverwalter und die Teammitglieder sichtbar.',
		salutation: 'Sehr geehrte Damen und Herren,',
		man: 'Herr',
		woman: 'Frau',
		male: 'Sehr geehrter',
		female: 'Sehr geehrte',
		reporterNoAccountNoNotification:
			'Melder hat kein Konto – keine Benachrichtigung möglich',
		createdBy: 'Angelegt von',
		createdInternally: 'Intern angelegt',
		createdInternallyBy: 'Intern angelegt von {name}',
		createdInternallyEditable:
			'Intern angelegt – Meldungstext von Team/Admin bearbeitbar.',
		createdByReporterReadonly:
			'Vom Melder selbst gemeldet – Meldungstext ist nicht änderbar.',
		commentGuestNeedsEmail:
			'Damit ein Gast diese Nachricht sieht, muss der Email-Versand gewählt werden.',
		commentDigestInfoHourly:
			'Benachrichtigungen zu Kommentaren werden gesammelt und stündlich in einer E-Mail verschickt.',
		commentDigestInfo:
			'Benachrichtigungen zu Kommentaren werden gesammelt und ca. alle {minutes} Minuten in einer E-Mail verschickt.',
		commentDigestInfoDaily:
			'Benachrichtigungen zu Kommentaren werden gesammelt und einmal täglich in einer E-Mail verschickt.',
		creatorRole: {
			admin: 'Administrator',
			team: 'Teammitglied',
			person: 'Person',
		},
	},
}
